import { render, staticRenderFns } from "./ManageUsersCreate.vue?vue&type=template&id=8c1c875a&scoped=true"
import script from "./ManageUsersCreate.vue?vue&type=script&lang=js"
export * from "./ManageUsersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1c875a",
  null
  
)

export default component.exports